import React from 'react';
import './ErrorBoundary.css';
import Helper from '../Helper';

interface IProps {
	children?: React.ReactNode;
}

interface IState {
	hasError: boolean;
}
export default class ErrorBoundary extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = { hasError: false };
	}
	static getDerivedStateFromError(error: any) {
		return { hasError: true };
	}

	componentDidCatch(error: any, errorInfo: any) {
		Helper.logError('ErrorBoundary', { error, errorInfo });
	}

	render() {
		if (this.state.hasError) {
			return (
				<div id='notfound'>
					<div className='notfound-bg' />
					<div className='notfound'>
						<div className='notfound-404'>
							<h1>500</h1>
						</div>
						<h2>Ups. Something went wrong...</h2>
						<a href={(process.env.REACT_APP_ROOT_PATH || '') + '/configurator/selection'} className='home-btn'>
							Go Home
						</a>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
